import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "currency", "rate", "amount", "amountLabel", "conversionHint", "method",
    "bankAccountField", "bankAccountSelect", "bankAccountNumber",
    "operationNumberField", "cipField", "statusSelect"
  ]

  connect() {
    this.calculateConversion()
    this.toggleMethodFields()
    this.updateBankAccountNumber()
  }

  updateBankAccountNumber() {
    if (!this.hasBankAccountSelectTarget || !this.hasBankAccountNumberTarget) return

    const selected = this.bankAccountSelectTarget.selectedOptions[0]
    const number = selected?.dataset?.accountNumber

    if (number) {
      this.bankAccountNumberTarget.textContent = number
      this.bankAccountNumberTarget.classList.remove("hidden")
    } else {
      this.bankAccountNumberTarget.textContent = ""
      this.bankAccountNumberTarget.classList.add("hidden")
    }
  }

  calculateConversion() {
    if (!this.hasCurrencyTarget || !this.hasRateTarget || !this.hasAmountTarget) return

    const currency = this.currencyTarget.value
    const rate = parseFloat(this.rateTarget.value) || parseFloat(this.element.dataset.paymentFormExchangeRateValue)
    const amount = parseFloat(this.amountTarget.value)

    if (currency === "USD") {
      if (this.hasAmountLabelTarget) this.amountLabelTarget.textContent = "Monto depositado (USD)"
      if (this.hasConversionHintTarget) this.conversionHintTarget.classList.add("hidden")
      return
    }

    if (this.hasAmountLabelTarget) this.amountLabelTarget.textContent = "Monto depositado (S/)"

    if (this.hasConversionHintTarget) {
      this.conversionHintTarget.classList.add("hidden")
    }
  }

  toggleMethodFields() {
    if (!this.hasMethodTarget) return
    const method = this.methodTarget.value
    const isPersisted = this.element.dataset.persisted === "true"
    
    if (method === "pago_efectivo") {
      if (this.hasCipFieldTarget) this.cipFieldTarget.classList.remove("hidden")
      if (this.hasBankAccountFieldTarget) this.bankAccountFieldTarget.classList.add("hidden")
      if (this.hasOperationNumberFieldTarget) this.operationNumberFieldTarget.classList.add("hidden")
      
      // Default to paid for PagoEfectivo if not saved yet
      if (this.hasStatusSelectTarget && !isPersisted) {
        this.statusSelectTarget.value = "paid"
      }
    } else if (method === "credit") {
      if (this.hasCipFieldTarget) this.cipFieldTarget.classList.add("hidden")
      if (this.hasBankAccountFieldTarget) this.bankAccountFieldTarget.classList.add("hidden")
      if (this.hasOperationNumberFieldTarget) this.operationNumberFieldTarget.classList.add("hidden")
      
      // Default to pending for Credit if not saved yet
      if (this.hasStatusSelectTarget && !isPersisted) {
        this.statusSelectTarget.value = "pending"
      }
    } else {
      if (this.hasCipFieldTarget) this.cipFieldTarget.classList.add("hidden")
      if (this.hasBankAccountFieldTarget) this.bankAccountFieldTarget.classList.remove("hidden")
      if (this.hasOperationNumberFieldTarget) this.operationNumberFieldTarget.classList.remove("hidden")
      
      // Default to paid for bank transfer if not saved yet
      if (this.hasStatusSelectTarget && !isPersisted) {
        this.statusSelectTarget.value = "paid"
      }
    }
  }
}
